let facebookLoaded = false;

export default function () {
    let api = {
        login() {
            return new Promise((resolve, reject) => {
                window.FB.login(function (response) {
                    response.authResponse
                        ? resolve(response.authResponse)
                        : reject('User cancelled login or did not fully authorize.');
                }, {scope: 'public_profile,email'});
            });
        },
    };

    return new Promise((resolve) => {
        const {VUE_APP_FACEBOOK_KEY} = process.env;

        let appId = VUE_APP_FACEBOOK_KEY;
        let sdkUri = 'https://connect.facebook.net/it_IT/sdk.js';

        if (!facebookLoaded) {
            let script = document.createElement('script');
            window.fbAsyncInit = () => {
                window.FB.init({
                    appId,
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: 'v4.0'
                });
            };
            script.onload = function () {
                facebookLoaded = true;
                resolve(api);
            };
            script.src = sdkUri;
            document.head.appendChild(script);
        } else {
            resolve(api);
        }
    })
}